import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Skeleton from './Skeleton';

const SelectSkeleton = ({ className, width, size }) => {
	const heights = {
		sm: '31px',
		md: '38px',
		lg: '48px',
	};

	return (
		<Skeleton
			className={classNames('skeleton-control', `skeleton-control-${size}`, className)}
			width={width}
			height={heights[size]}
			rounded='md'
		/>
	);
};

SelectSkeleton.propTypes = {
	className: PropTypes.string,
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	size: PropTypes.oneOf(['sm', 'md', 'lg']),
};

SelectSkeleton.defaultProps = {
	className: null,
	width: '100%',
	size: 'md',
};

export default SelectSkeleton;
